import { getAdditionalFeesOrderItems } from './getAdditionalFeesOrderItems';
import { OrderItemType } from '@wix/cashier-express-checkout-widget/dist/src/types/OrderItem';
import { checkIfItemHasDiscount } from './discounts.utils';
const MAX_ITEM_NAME_LENGTH = 1200;
function lineItemToCashierLineItem(lineItem, /* istanbul ignore next */
discountsToAlignWith) {
  var _lineItem$unitPrice, _lineItem$salePrice;
  if (discountsToAlignWith === void 0) {
    discountsToAlignWith = [];
  }
  const amount = ((_lineItem$unitPrice = lineItem.unitPrice) == null ? void 0 : _lineItem$unitPrice.amount) ?? /* istanbul ignore next */'0';
  const priceBeforeDiscounts = ((_lineItem$salePrice = lineItem.salePrice) == null ? void 0 : _lineItem$salePrice.amount) ?? '0';
  const price = checkIfItemHasDiscount(lineItem, discountsToAlignWith) ? priceBeforeDiscounts : amount;
  return {
    id: lineItem.id,
    name: getItemName(lineItem),
    price,
    quantity: lineItem.confirmedQuantity ?? /* istanbul ignore next */0,
    type: OrderItemType.Product
  };
}
export function getOrderItemsFromCheckout(expressModel, /* istanbul ignore next */
discountsToAlignWith) {
  var _expressModel$lineIte;
  if (discountsToAlignWith === void 0) {
    discountsToAlignWith = [];
  }
  const orderItems = ((_expressModel$lineIte = expressModel.lineItems) == null ? void 0 : _expressModel$lineIte.map(lineItem => lineItemToCashierLineItem(lineItem, discountsToAlignWith))) ?? /* istanbul ignore next */[];
  const additionalFeesAsOrderItems = getAdditionalFeesOrderItems(expressModel.additionalFees ?? /* istanbul ignore next */[]);
  return [...orderItems, ...additionalFeesAsOrderItems];
}
function getItemName(lineItem) {
  const {
    name,
    description
  } = lineItem;
  const displayName = description ? `${name}${description}` : name;
  if (displayName.length > MAX_ITEM_NAME_LENGTH) {
    return displayName.substring(0, MAX_ITEM_NAME_LENGTH);
  }
  return displayName;
}
//# sourceMappingURL=getOrderItemsFromCheckout.js.map